"use client";

import React from "react";
import { Linkedin, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const speakers = [{
  id: "alessandro-visconti",
  name: "Alessandro Visconti",
  title: "Senior Partner",
  organization: "International Corporate Law",
  bio: "Alessandro leads the firm's cross-border litigation practice with over twenty years of experience in complex corporate restructuring and international arbitration. His strategic approach ensures robust protection for multinational clients.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_1.png",
  linkedin: "https://www.linkedin.com/",
  initials: "AV"
}, {
  id: "elena-rossi",
  name: "Elena Rossi",
  title: "Lead Counsel",
  organization: "Intellectual Property & Tech",
  bio: "Elena specializes in the protection of digital assets and patent litigation, advising global technology firms on compliance and strategic portfolio management within the European regulatory framework.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_2.png",
  linkedin: "https://www.linkedin.com/",
  initials: "ER"
}, {
  id: "marco-bianchi",
  name: "Marco Bianchi",
  title: "Associate",
  organization: "Regulatory Compliance",
  bio: "Marco provides expert guidance on financial regulations and corporate governance, ensuring that clients navigate the evolving landscape of legal standards with precision and absolute adherence to the rule of law.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/professional_3.png",
  linkedin: "https://www.linkedin.com/",
  initials: "MB"
}];
export default function PonentesDestacados() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}